/**
 * event-ingress
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 0.1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */ /* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from "@angular/core";
import {
  HttpClient,
  HttpHeaders,
  HttpParams,
  HttpResponse,
  HttpEvent,
} from "@angular/common/http";
import { CustomHttpUrlEncodingCodec } from "../encoder";

import { Observable } from "rxjs";

import { RealTimeStatistic } from "../model/real-time-statistic/realTimeStatistic";

import { BASE_PATH, COLLECTION_FORMATS } from "../variables";
import { Configuration } from "../configuration";

@Injectable()
export class RealTimeStatisticService {
  protected basePath = "https://real-time-statistic-dev.sky-scout.ga";
  public defaultHeaders = new HttpHeaders();
  public configuration = new Configuration();

  constructor(
    protected httpClient: HttpClient,
    @Optional() @Inject(BASE_PATH) basePath: string,
    @Optional() configuration: Configuration
  ) {
    if (basePath) {
      this.basePath = basePath;
    }
    if (configuration) {
      this.configuration = configuration;
      this.basePath = basePath || configuration.basePath || this.basePath;
    }
  }

  /**
   * @param consumes string[] mime-types
   * @return true: consumes contains 'multipart/form-data', false: otherwise
   */
  private canConsumeForm(consumes: string[]): boolean {
    const form = "multipart/form-data";
    for (const consume of consumes) {
      if (form === consume) {
        return true;
      }
    }
    return false;
  }

  /**
   *
   *
   * @param competitionId
   * @param competitorId
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getRealTimeStatistic(
    competitionId: string,
    competitorId?: string,
    observe?: "body",
    reportProgress?: boolean
  ): Observable<RealTimeStatistic>;
  public getRealTimeStatistic(
    competitionId: string,
    competitorId?: string,
    observe?: "response",
    reportProgress?: boolean
  ): Observable<HttpResponse<RealTimeStatistic>>;
  public getRealTimeStatistic(
    competitionId: string,
    competitorId?: string,
    observe?: "events",
    reportProgress?: boolean
  ): Observable<HttpEvent<RealTimeStatistic>>;
  public getRealTimeStatistic(
    competitionId: string,
    competitorId?: string,
    observe: any = "body",
    reportProgress: boolean = false
  ): Observable<any> {
    if (competitionId === null || competitionId === undefined) {
      throw new Error(
        "Required parameter competitionId was null or undefined when calling getRealTimeStatistic."
      );
    }

    let queryParameters = new HttpParams({
      encoder: new CustomHttpUrlEncodingCodec(),
    });
    if (competitorId !== undefined && competitorId !== null) {
      queryParameters = queryParameters.set("competitorId", <any>competitorId);
    }

    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = ["application/json"];
    const httpHeaderAcceptSelected:
      | string
      | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set("Accept", httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [];

    return this.httpClient.request<RealTimeStatistic>(
      "get",
      `${this.basePath}/api/real-time-statistic/${encodeURIComponent(
        String(competitionId)
      )}`,
      {
        params: queryParameters,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }
}
